export class AutomatOperator {
    constructor() {}
    _id?:string;
    name: string;
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/models/automatOperator.ts